import {EditorDialog} from "./components/editorDialog";

export default EditorDialog;